export function deepcopy(o) {
  return JSON.parse(JSON.stringify(o));
}

export function setValue(obj, _keys, value, ref) {
  let keys;
  if (_keys.constructor.name === "String") keys = _keys.split(".");
  else if (_keys.constructor.name === "Array") keys = _keys;
  if (keys.length == 1) {
    if (value === undefined || value === null) {
      delete obj[keys[0]];
    } else {
      if (value.constructor.name === "Object" && value.from !== undefined && value.to !== undefined) {
        if (obj[keys[0]] == value.from) obj[keys[0]] = value.to;
        if (obj[keys[0]].constructor.name === "Array") {
          if (value.from.constructor.name === "Array") {
            let ind = obj[keys[0]].map((d, i) => value.from.filter(e => _.isEqual(d, e)).length > 0 ? i : undefined).filter(d => d !== undefined);
            if (value.to.constructor.name === "Array") {
              ind.forEach(i => {
                obj[keys[0]][i] = value.to[value.fromindexOf(obj[keys[0]][i])]
              });
            } else {
              ind.forEach(i => { obj[keys[0]][i] = value.to });
            }
          } else {
            let ind = obj[keys[0]].map((d, i) => _.isEqual(d, value.from) ? i : undefined).filter(d => d !== undefined);
            ind.forEach(i => { obj[keys[0]][i] = value.to });
          }
        }
      } else if (value.constructor.name === "Object" && value.prod !== undefined) {
        if (obj[keys[0]].endsWith("%")) {
          obj[keys[0]] = (parseFloat(obj[keys[0]]) * value.prod) + "%";
        }
        else obj[keys[0]] = obj[keys[0]] * value.prod
      } else if (value.constructor && value.by !== undefined) {
        if (obj[keys[0]].endsWith("%")) {
          obj[keys[0]] = (parseFloat(obj[keys[0]]) + (value.by / ref * 100)) + "%";
        }
        else obj[keys[0]] = obj[keys[0]] + value.by
      } else {
        obj[keys[0]] = value;
      }
    }
  } else if (keys.length > 1) {
    if (obj[keys[0]] == undefined) obj[keys[0]] = {};
    obj[keys[0]] = setValue(obj[keys[0]], keys.slice(1), value);
  }
  return obj;
}

export function makeFlatObject(obj) {
  function deepcopy(o) {
    return JSON.parse(JSON.stringify(o));
  }
  if (obj.constructor.name === "Object") {
    let res = {};
    Object.keys(obj).forEach(key => {
      if (obj[key].constructor.name === "Object") {
        let tempObj = makeFlatObject(obj[key]);
        Object.keys(tempObj).forEach(tempkey => {
          res[key + "." + tempkey] = (typeof tempObj[tempkey] === "array" ? deepcopy(tempObj[tempkey]) : tempObj[tempkey]);
        })
      } else {
        res[key] = (typeof obj[key] === "array" ? deepcopy(obj[key]) : obj[key]);
      }
    })
    return res;
  } else {
    return obj;
  }
}

export async function MapRescale(spec, original) {
  let specSize = {
    width: spec.layout?.width,
    height: spec.layout?.height,
    size: spec.layout?.width * spec.layout?.height,
    scale: spec.layout?.projection?.scale,
    transpose: spec.layout?.projection?.transpose || false
  }
  let originSize = {
    width: original.layout?.width,
    height: original.layout?.height,
    size: original.layout?.width * original.layout?.height,
    scale: original.layout?.projection?.scale,
    transpose: original.layout?.projection?.transpose || false
  }
  let scaleRate = Math.sqrt((specSize.width * specSize.height) / (originSize.width * originSize.height));
  if (specSize.transpose != originSize.transpose) {
    let whRate = [(specSize.width / originSize.height), (specSize.height / originSize.width)];
    spec.layout.projection.scale = originSize.scale * scaleRate || spec.layout.projection.scale;
    if (spec.layout?.projection?.translate) {
      spec.layout.projection.translate = deepcopy(spec.layout.projection.translate).reverse().map((d, i) => d * (whRate[i] || 1));
      spec.layout.projection.translate[0] = spec.layout.projection.translate[0] * 1.2;
    }
  } else {
    let whRate = [(specSize.width / originSize.width), (specSize.height / originSize.height)];
    if (spec.layout?.projection?.scale) spec.layout.projection.scale = originSize.scale * scaleRate || spec.layout.projection.scale;
    if (spec.layout?.projection?.translate) {
      spec.layout.projection.translate = deepcopy(spec.layout.projection.translate).map((d, i) => d * (whRate[i] || 1));
    }
  }
  return spec;
}

export function makeFilterFunction(fObj, isAtomic) {
  let filterState;
  if (fObj.constructor.name === "Object") filterState = toFilterString(fObj);
  else if (fObj.constructor.name === "Array") filterState = toFilterString(fObj);
  else if (fObj.constructor.name === "String") filterState = fObj;

  return function (datum) {
    // pass a "single" datum row
    let preEval = `function startsWith(val, str) {
      return val.startsWith(str);
    }
    function endsWith(val, str) {
      return val.endsWith(str);
    }
    function startsEndsWith(val, start, end) {
      return val.startsWith(start) && val.endsWith(end);
    }
    function includes(val, str) {
      return val.includes(str);
    }
    function pattern(val, expr) {
      return val.match(expr).length > 0;
    }
    function oneOf(val, arr) {
      return arr.includes(val);
    }`
    if (isAtomic) return eval(preEval + filterState.replace(/datum\.value/g, JSON.stringify(datum)))
    else return eval(preEval + filterState.replace(/datum/g, JSON.stringify(datum)))
  }
}

export function toFilterString(fObj) {
  // const operators = ["eq", "neq", "leq", "geq", "lt", "gt", "range", "xrange", "startsWith", "endsWith", "startsEndsWith", "includes", "pattern", "oneOf"];
  function makeAtomicStatement(fieldname, elem, op) {
    if (op === "eq") {
      if (typeof elem == "string") return "datum." + fieldname + " == '" + elem.toString() + "'";
      else return "datum." + fieldname + " == " + elem.toString() + "";
    } else if (op === "neq") {
      if (typeof elem == "string") return "datum." + fieldname + " != '" + elem.toString() + "'";
      else return "datum." + fieldname + " != " + elem.toString() + "";
    } else if (op === "oneOf") {
      return "oneOf(datum." + fieldname + ", [" + elem.map(d => (typeof d == "string" ? "'" + d + "'" : d.toString())).join(", ") + "])";
    } else if (op === "leq") {
      return "datum." + fieldname + " <= " + elem.toString();
    } else if (op === "geq") {
      return "datum." + fieldname + " >= " + elem.toString();
    } else if (op === "lt") {
      return "datum." + fieldname + " < " + elem.toString();
    } else if (op === "gt") {
      return "datum." + fieldname + " > " + elem.toString();
    } else if (op === "range") {
      let min = (elem[0] > elem[1] ? elem[1] : elem[0]),
        max = (elem[0] < elem[1] ? elem[1] : elem[0]);
      return "(datum." + fieldname + " >= " + min.toString() + " && datum." + fieldname + " <= " + max.toString() + ")";
    } else if (op === "xrange") {
      let min = (elem[0] > elem[1] ? elem[1] : elem[0]),
        max = (elem[0] < elem[1] ? elem[1] : elem[0]);
      return "(datum." + fieldname + " > " + min.toString() + " && datum." + fieldname + " < " + max.toString() + ")";
    } else if (op === "startsWith") {
      return "startsWith(datum." + fieldname + ", '" + elem + "')";
    } else if (op === "endsWith") {
      return "endsWith(datum." + fieldname + ", '" + elem + "')";
    } else if (op === "startsEndsWith") {
      return "startsEndsWith(datum." + fieldname + ", '" + elem[0] + ", " + elem[1] + "')";
    } else if (op === "includes") {
      return "includes(datum." + fieldname + ", '" + elem + "')";
    } else if (op === "pattern") {
      return "pattern(datum." + fieldname + ", /" + elem + "/g)";
    }
  }

  function makeSingleStatement(fieldname, object) {
    if (fieldname == null) fieldname = "value"
    if (object.constructor.name === "Object" && object.not !== undefined) {
      return "!" + makeSingleStatement(fieldname, object.not);
    } else {
      if (object.constructor.name === "Array") { // list of operators
        return "(" + object.map(item => {
          return makeSingleStatement(fieldname, item);
        }).join(" || ") + ")";
      } else if (object.constructor.name === "Object") { // list of operators
        return "(" + Object.keys(object).map(op => {
          return makeAtomicStatement(fieldname, object[op], op);
        }).join(" && ") + ")";
      } else { // a value
        return makeAtomicStatement(fieldname, object, "eq");
      }
    }
  }

  if (fObj.constructor.name === "Object") {
    // first-level: fields;
    return "(" + Object.keys(fObj).map(fieldname => {
      return makeSingleStatement(fieldname, fObj[fieldname]);
    }).join(" && ") + ")"
  } else if (fObj.constructor.name === "Array") {
    return "(" + fObj.map(d => toFilterString(d)).join(" || ") + ")"
  } else {
    return makeSingleStatement(null, fObj)
  }
}

export function optionOperation(o, n, ref) {
  if (o === undefined) o = 0;
  if (n?.constructor.name === "Object") {
    if (n.by !== undefined) {
      if (o.constructor.name === "String" && o.endsWith("%") && ref !== undefined) {
        return (parseFloat(o) + (n.by / ref * 100)) + "%";
      }
      else return (parseFloat(o) || 0) + n.by;
    } else if (n.prod !== undefined) {
      return (parseFloat(o) || 0) * n.prod;
    }
    return n;
  } else {
    return n;
  }
}

export function evalExpression(expr, field, value, data, autoGroupby, config) {
  let preEval = `
  function round(n, d) {
    let b = Math.pow(10, d);
    return Math.round(n * b) / b;
  }
  function equal(a, b) {
    return a == b;
  }
  function sum(f, g) {
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      return data.filter(d => equal(d[field], value)).reduce((acc, cur) => acc + cur[f], 0);
    } else { // do not group-by
      return data.reduce((acc, cur) => acc + cur[f], 0);
    }
  }
  function count(f, g) {
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      return data.filter(d => equal(d[field], value)).length;
    } else { // do not group-by
      return data.length;
    }
  }
  function mean(f, g) {
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      let fil = data.filter(d => equal(d[field], value));
      return fil.reduce((acc, cur) => acc + cur[f], 0) / fil.length;
    } else { // do not group-by
      return data.reduce((acc, cur) => acc + cur[f], 0) / data.length;
    }
  }
  function median(f, g) {
    let vals, n;
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      vals = data.filter(d => equal(d[field], value)).map(cur => cur[f]);
    } else { // do not group-by
      vals = data.map(cur => cur[f]);
    }
    vals.sort();
    n = vals.length;
    if (n % 2 == 0) return (vals[n / 2 - 1] + vals[n / 2 + 1]) / 2
    else return vals[Math.floor(n / 2)];
  }
  function max(f, g) {
    let vals;
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      vals = data.filter(d => equal(d[field], value)).map(cur => cur[f]);
    } else { // do not group-by
      vals = data.map(cur => cur[f]);
    }
    vals.sort();
    return vals[0];
  }
  function min(f, g) {
    let vals, n;
    if ((g !== undefined && g === true) || (g === undefined && autoGroupby)) { // does group-by
      vals = data.filter(d => equal(d[field], value)).map(cur => cur[f]);
    } else { // do not group-by
      vals = data.map(cur => cur[f]);
    }
    vals.sort();
    n = vals.length;
    return vals[n - 1];
  }
  function isFirst(f, dt) {
    return equal(config.datatype[f].order?.[0], dt[f]);
  }
  function isLast(f, dt) {
    return equal(config.datatype[f].order?.[config.datatype[f].order?.length - 1], dt[f]);
  }
  `;
  function format(d, fo) {
    return d3.format(fo)(d);
  }
  let formattingStatements = expr.match(/format\(([^,]+\,\s+['"][^'"]+['"])\)/gi) || [];

  for (const f of formattingStatements) {
    if (f.startsWith("format(") && f.endsWith(")")) {
      let s = eval(
        `function format(a, b) {return [a, b]}` + f
      );
      let o = format(s[0], s[1]);
      expr = expr.replace(f, "\"" + o + "\"");
    }
  }

  if (config?.format !== null && config?.format !== undefined) {
    return d3.format(config.format)(eval(preEval + expr));
  } else {
    return eval(preEval + expr);
  }
}

export function covertMarkConditionPredicateToObject(pred) {
  let obj = {};
  pred.replace(/^\(/, "").replace(/\)$/, "").split(" && ").forEach((cond) => {
    let s = cond.split(" == ");
    obj[s[0].replace(/^datum\./, "")] = JSON.parse(s[1] || '""');
  });
  return obj;
}
export function covertMarkConditionObjectToPredicate(obj) {
  let predicate = Object.keys(obj).map((dkey) => { return `datum.${dkey} == ${JSON.stringify(obj[dkey])}` }).join(" && ");
  return `(${predicate})`
}
export function datumMatch(o1, o2, o1_under_o2 = false) {
  if (o1 === o2) return true;
  else if (!o1 || !o2) return false;
  else if (o1.constructor.name === "Object" && o2.constructor.name === "Object") {
    if (o1_under_o2) {
      if (Object.keys(o1).length < Object.keys(o2).length) return false;
      let res = true;
      Object.keys(o2).forEach(key => {
        if (o1[key] !== o2[key]) res = false;
      });
      return res;
    } else {
      if (Object.keys(o1).length != Object.keys(o2).length) return false;
      let res = true;
      if (Object.keys(o1).length > 0) {
        Object.keys(o1).forEach(key => {
          if (o1[key] !== o2[key]) res = false;
        });
      } else {
        Object.keys(o2).forEach(key => {
          if (o1[key] !== o2[key]) res = false;
        });
      }
      return res;
    }
  }
}